module.exports = __webpack_public_path__ + "static/media/19ESCAP19.52126b3d.jpg";